(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hogare-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBeforeAfter(root) {
      if (root.dataset.hogareBeforeAfterReady) return;
      var input = root.querySelector('[data-hogare-before-after-input]');
      var clip = root.querySelector('[data-hogare-before-after-clip]');
      var handle = root.querySelector('[data-hogare-before-after-handle]');
      if (!input || !clip || !handle) return;
      root.dataset.hogareBeforeAfterReady = 'true';

      function update() {
        var value = input.value;
        clip.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
        handle.style.left = value + '%';
      }

      input.addEventListener('input', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-hogare-before-after]').forEach(initBeforeAfter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hogare-video-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLazyVideos(root) {
      var videos = root.querySelectorAll('[data-hogare-lazy-video]');
      if (!videos.length || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );
      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    function initAll() {
      document.querySelectorAll('.hogare-video-grid-section').forEach(initLazyVideos);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
